// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_statusChangePolicy(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "MatchStatusChangeAllowed",
    "MatchStatusChangeForbidden"
  ]);
}

let fragmentConverter = {"__root":{"statusChangePolicy":{"u":"fragment_statusChangePolicy"}}};

let fragmentConverterMap = {
  fragment_statusChangePolicy: unwrap_fragment_statusChangePolicy
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function matchStatusChangeForbiddenReson_decode($$enum) {
  if ($$enum === "NOT_MATCH_OWNER") {
    return $$enum;
  }
}

let matchStatusChangeForbiddenReson_fromString = matchStatusChangeForbiddenReson_decode;

let Utils = {
  matchStatusChangeForbiddenReson_decode: matchStatusChangeForbiddenReson_decode,
  matchStatusChangeForbiddenReson_fromString: matchStatusChangeForbiddenReson_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "ToggleMatchDismissButton_matchV5",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dismissed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "statusChangePolicy",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/)
          ],
          "type": "MatchStatusChangeAllowed",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "reason",
              "storageKey": null
            }
          ],
          "type": "MatchStatusChangeForbidden",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "MatchV5",
  "abstractKey": "__isMatchV5"
};
})());

let wrap_fragment_statusChangePolicy = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_statusChangePolicy = unwrap_fragment_statusChangePolicy;
exports.wrap_fragment_statusChangePolicy = wrap_fragment_statusChangePolicy;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
